import { Dialog } from 'primereact/dialog'
import React, { useContext, useRef, useState } from 'react'
import { CommonContext } from '../../common/context/commonContext'
import { TakebackRecycleDialogProps, TakebackRecycleWait } from '../../../types/inbound'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { useMountEffect } from 'primereact/hooks'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const TakebackRecycleDialog = (props: TakebackRecycleDialogProps) => {
    const { $http, $toast } = useContext(CommonContext)
    const { t } = useTranslation()

    const scanRef = useRef<HTMLInputElement>(null)
    const [lctSeq, setLctSeq] = useState<string>()
    const [params, setParams] = useState<TakebackRecycleWait>(props.info)

    useMountEffect(() => {
        setTimeout(() => scanRef.current?.focus(), 100)
    })

    const onKeyDownSearch = async (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            setParams({
                ...params,
                lctSeq,
            })
            const result = await $http().put('/inbound/recycle', {
                ...params,
                lctSeq,
            })

            if (result && result.isProcess) {
                $toast({
                    title: t(tokens.common.success),
                    text: result.message,
                    icon: 'success',
                })
                props.onHide && props.onHide(true)
            }
        }
    }
    const footer = () => {
        // SALES
        return (
            <>
                <Button
                    className="mt-1 w-full p-button-secondary"
                    label={t(tokens.common.close)}
                    size="large"
                    onClick={() => props.onHide && props.onHide(false)}
                />
            </>
        )
    }

    return (
        <Dialog
            header={t(tokens.inventory.scan_the_location_of_the_quality_product_stack)}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide(false)}
            closable={false}
            contentClassName="pb-0"
            footer={footer}
        >
            <div className="flex grid m-0 mb-3">
                <span className="p-input-icon-left mt-1">
                    <i className="pi pi-map-marker" />
                    <InputText
                        ref={scanRef}
                        value={lctSeq}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.inventory.scanning_the_staging_location)}
                        onChange={(e) => setLctSeq(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                    />
                </span>
            </div>
        </Dialog>
    )
}

export default TakebackRecycleDialog
